import {useState} from 'react';
import {Button} from '@cap4/ui';
import {Copy,PlugZap} from 'lucide-react';
import './codex-setup.css';

const serverUrl='https://publish.cap4.dk/mcp';
const testPrompt='Brug CAP4Publish til at vise de kanaler, jeg har adgang til. Du må ikke ændre eller publicere noget.';

function CopyText({text,label}:{text:string;label:string}){
  const [feedback,setFeedback]=useState('');
  async function copy(){
    try{
      await navigator.clipboard.writeText(text);
      setFeedback('Kopieret.');
    }catch{
      setFeedback('Kunne ikke kopiere. Markér teksten ovenfor, og kopiér den manuelt.');
    }
  }
  return <div className="codex-setup-copy"><Button size="sm" variant="secondary" icon={Copy} onClick={()=>void copy()}>{label}</Button><span role="status">{feedback}</span></div>;
}

export function CodexSetupGuide(){
  return <section className="codex-setup" aria-labelledby="codex-setup-title">
    <div className="codex-setup-heading"><PlugZap size={23} aria-hidden="true"/><div><h3 id="codex-setup-title">Tilslut CAP4Publish til Codex</h3><p>CAP4Publish kører allerede online. Forbind Codex på din computer, og vælg selv, hvad agenten må gøre.</p></div></div>
    <ol className="codex-setup-steps">
      <li><h4>Tilføj forbindelsen i Codex</h4><p>Åbn <strong>Settings → Plugins → Connect to a custom MCP</strong>, og udfyld:</p>
        <dl className="codex-setup-fields"><div><dt>Name</dt><dd>CAP4Publish</dd></div><div><dt>Type</dt><dd>Streamable HTTP</dd></div><div><dt>URL</dt><dd><code>{serverUrl}</code><CopyText text={serverUrl} label="Kopiér adresse"/></dd></div></dl>
        <p>Klik <strong>Save</strong>.</p>
      </li>
      <li><h4>Log ind, og vælg adgang</h4><p>Vælg login for <strong>CAP4Publish</strong>, hvis Codex ikke selv åbner browseren. Log ind i CAP4Publish, og vælg kanaler og udløb. Vælg <strong>Læs</strong>, hvis du blot vil teste, og godkend adgangen.</p></li>
      <li><h4>Prøv forbindelsen i en ny samtale</h4><p>Vend tilbage til Codex, start en ny samtale, og send:</p><blockquote>{testPrompt}</blockquote><CopyText text={testPrompt} label="Kopiér testbesked"/><p>Forbindelsen er klar, når Codex kan hente dine kanaler fra CAP4Publish. Du kan tilbagekalde adgangen herunder.</p></li>
    </ol>
  </section>;
}
